<template>
    <el-form size="small" :inline="true" :model="filterForm" ref="filterForm" class="filter-form">
        <el-form-item label="日期" prop="classTime" class="auto-width">
            <el-date-picker
                v-model="filterForm.classTime"
                type="daterange"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="handleDateRangeChange(0)">
            </el-date-picker>
        </el-form-item>
        <el-form-item class="auto-width" prop="type">
            <el-button size="small" @click="handleDateRangeChange(1)" :class="{'clickCss': this.filterForm.type == 1}">今天</el-button>
            <el-button size="small" @click="handleDateRangeChange(2)" :class="{'clickCss': this.filterForm.type == 2}">本周</el-button>
            <el-button size="small" @click="handleDateRangeChange(3)" :class="{'clickCss': this.filterForm.type == 3}">本月</el-button>
        </el-form-item><br />
        <el-form-item class="marginLeft">
            <el-button type="primary" @click="filterFormSubmit('filterForm')" :loading="loading">查询</el-button>
            <el-button type="default" plain @click="filterFormReset('filterForm')">重置</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    import { COMMON } from '@/common/api'

    export default {
        props: {
            loading: '' // 接收父组件表格loading
        },
        data() {
            return {
                pickerOptions: {
                    firstDayOfWeek: 1
                },
                filterForm: { // 查询表单
                    classTime: [], // 日期 [起始日期，截止日期]
                    type: 1 // 特定时间段
                }
            }
        },
        methods: {
            /**
             * [handleDateRangeChange description] 日期时间变化
             * @param  {[type]} type [description]
             * @return {[type]}      [description]
             */
            handleDateRangeChange: function(type) {
                this.filterForm.type = type;

                switch (type) {
                    case 1:
                        this.filterForm.classTime = [];
                        this.filterForm.classTime.push(COMMON.formatDate(1, '-', new Date()));
                        this.filterForm.classTime.push(COMMON.formatDate(1, '-', new Date()));
                        break;
                    case 2:
                        this.filterForm.classTime = COMMON.getNowWeek();
                        break;
                    case 3:
                        this.filterForm.classTime = COMMON.getNowMonth();
                        break;
                    default:
                        break;
                }
            },
            /**
             * [filterFormSubmit description] 表单提交
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            filterFormSubmit(){
                this.$emit('searchForm', COMMON.formatterDateRange(this.filterForm.classTime[0], this.filterForm.classTime[1]));
            },
            /**
             * [filterFormReset description] 表单重置
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            filterFormReset(filterForm){
                this.$refs[filterForm].resetFields();

                // 重置之后还是默认选中今天
                this.filterForm.classTime.push(COMMON.formatDate(1, '-', new Date()));
                this.filterForm.classTime.push(COMMON.formatDate(1, '-', new Date()));
            }
        },
        mounted() {
            this.filterForm.classTime.push(COMMON.formatDate(1, '-', new Date()));
            this.filterForm.classTime.push(COMMON.formatDate(1, '-', new Date()));
            this.filterFormSubmit();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../common/styles/base/mixin-font";
    @import "../../common/styles/base/mixin-common";

    ::v-deep .clickCss{
        color: $themeColor;
        background-color: $colorBtn;
        border-color: $borderColor;
    }
    .marginLeft{
        margin-left: 35px;
    }
</style>